import { TNameTitle } from '@interfaces/common/common';
import { IItemsResponse } from '@interfaces/common/response';
import { IRUDashboardStatusDTO, IRUNetworkElementId, IRUStatusDashboardToggleAvailabilityDTO, IRUStatusDashboardUpdateCarrierDTO } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';
import { ICarrier, IRUStatusDashboard } from '@interfaces/ruStatusDashboard/ruStatusDashboard';

import { client } from './client';
import { URL } from './urls';

const {
	ruDashboardFilter,
	ruDashboardStatic,
	ruDashboard,
} = URL;

export const getRUDashboardStates = (params: IRUDashboardStatusDTO): Promise<IItemsResponse<IRUStatusDashboard>> => {
	return client.get(ruDashboardFilter, { params });
};

export const getRUStatusDashboardAdministrativeState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/administrative-state`);
};

export const getRUStatusDashboardOperationalState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/operational-state`);
};

export const getRUStatusDashboardUsageState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/usage-state`);
};

export const getRUStatusDashboardPowerState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/power-state`);
};

export const getRUStatusDashboardAvailabilityState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/availability-state`);
};

export const getRUStatusDashboardSynchronizationState = (): Promise<TNameTitle[]> => {
	return client.get(`${ruDashboardStatic}/synchronisation-state`);
};

export const getRUStatusDashboardCarriersState = ({ ruNetworkElementId }: IRUNetworkElementId): Promise<ICarrier[]> => {
	return client.get(`${ruDashboard}/txrx-states`, { params: { ruNetworkElementId } });
};

export const getRUStatusDashboardXMLInterface = ({ ruNetworkElementId }: IRUNetworkElementId): Promise<string> => {
	return client.get(`${ruDashboard}/interfaces`, { params: { ruNetworkElementId } });
};

export const lockRUStatusDashboardAdministrativeState = (
	{ id, ...params }: IRUStatusDashboardToggleAvailabilityDTO,
): Promise<void> => {
	return client.get(`${ruDashboard}/${id}/update`, { params });
};

export const updateRUStatusDashboardCarrierState = (
	dto: IRUStatusDashboardUpdateCarrierDTO,
): Promise<void> => {
	return client.post(`${ruDashboard}/update-carrier-state`, dto);
};
